// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".video-card ._kwai-player-poster_uxc1a_19 {\n  height: 35vw;\n  background: #f2f2f2 center/100% no-repeat;\n  object-fit: cover;\n  border-radius: 0.41667vw;\n}\n.video-card ._kwai-player_uxc1a_2,\n.video-card ._kwai-player-video-interactive_uxc1a_11,\n.video-card ._kwai-player-video_uxc1a_11 {\n  height: 35vw;\n}\n.video-card video {\n  height: 35vw;\n  background: #f2f2f2 center/100% no-repeat;\n  object-fit: cover;\n  border-radius: 0.41667vw;\n}\n", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
